export async function getList({ /*token,*/ uid, prjId, targetDt }) {
    const url = 'https://reports.imon.gulfnet-cloud.com/v1/alarms';
    const params = { /*token: token,*/ uid: uid, prjId: prjId, targetDt: targetDt.toISOString() };
    const query_params = new URLSearchParams(params);
    //return await fetch(url + '?' + query_params);
    const init_params = {
        credentials: "same-origin"
    }
    const res = await fetch(url + '?' + query_params, init_params);
    //const results = JSON.parse(res.json());
    //const results = JSON.parse(await res.json());
    const results = res.json();

    let alarmsData = {ids:[],namespaces:[],map:{},alarms:{},compositeIds:[]};
    alarmsData['targetDt'] = Date.parse(results.targetDt);  // ToDo: parse check
    for (const alarm of results.alarms) {
        alarmsData.ids.push(alarm.id);
        alarmsData.alarms[alarm.id] = alarm;
        if (alarm.type === 'Metric') {
            if (alarmsData.namespaces.includes(alarm.namespace) < 0) {
                alarmsData.namespaces.push(alarm.namespace);
                alarmsData.map[alarm.namespace] = [];
            }
            alarmsData.map[alarm.namespace].push(alarm.id);
            //alertsData.alerts.push(result);
        } else {
            alarmsData.compositeIds.push(alarm.id)
        }
    }
    return alarmsData;
}
